export const reportFormat = {
  PDF: {
    value: 'PDF',
    label: 'PDF',
    icon: 'mdi-file-pdf',
    color: 'red'
  },
  XLSX: {
    value: 'XLSX',
    label: 'Excel',
    icon: 'mdi-file-excel',
    color: 'green'
  },
  TXT: {
    value: 'TXT',
    label: 'Text',
    icon: 'mdi-file-document',
    color: 'black'
  }
}
